var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.995 12.5q2.276 0 3.89-1.6Q12.5 9.303 12.5 7.006q0-2.276-1.61-3.89Q9.277 1.5 7 1.5q-2.298 0-3.9 1.61Q1.5 4.723 1.5 7q0 2.298 1.6 3.9 1.598 1.6 3.895 1.6M7 14q-1.456 0-2.728-.552a7.2 7.2 0 0 1-2.23-1.5A6.89 6.89 0 0 1 0 7Q0 5.563.552 4.28a7.1 7.1 0 0 1 1.495-2.23 7 7 0 0 1 2.218-1.5A6.8 6.8 0 0 1 6.998 0q1.44 0 2.72.552a7.1 7.1 0 0 1 2.23 1.5 7.1 7.1 0 0 1 1.5 2.226Q14 5.557 14 7.001q0 1.249-.415 2.363a7.4 7.4 0 0 1-1.148 2.032L16 14.958 14.938 16l-3.563-3.542a7.1 7.1 0 0 1-2.019 1.137A6.8 6.8 0 0 1 7 14"
  })));
};
export default SvgSearch;